<template>
  <div v-if="!showRequest && !this.active.hasOwnProperty('FSerial')">
    <v-card class="fullForm">
      <div class="fullText">
        <h3>
          شرايط و مراحل ثبت درخواست دريافت کمک هزینه اجاره مسکن طلاب حوزه علميه
          مشهد مقدس:
        </h3>
        <br />
        <ol>
          <li>
            تكميل فرم اطلاعات نرم افزاري از طريق پورتال طلاب (همین سایت)
          </li>
          <li>
            تعيين دو نفر ضامن داراي پرونده فعال وشهریه بگیر،از طريق پورتال طلاب
            كه اطمينان داشته باشيد ضمانت شما را خواهند پذيرفت
          </li>
          <li>
            اطلاع رساني به ضامنین جهت مراجعه به پورتال طلاب و تاييد ضمانت
          </li>
          <li>
            <b style="color : red">
              طلاب تحت برنامه مدارس ( غیر ازمجازی )می بایست قولنامه خود را اعم
              از دستی یا رسمی به تایید مدرسه (مهرتایید مدرسه بر روی قولنامه)
              برسانند.
            </b>
          </li>
          <li>
            هنگام ثبت درخواست، تصویر اجاره‌نامه را اسکن نموده و پیوست نمایید.
            نیاز به مراجعه حضوری و تلفنی به مرکز نیست.می‌توانید به صفحه
            <a href="https://portal.hozehkh.com/home-request-active">سوابق کمک هزینه مسکن</a>
            مراجعه کنید
          </li>
          <li>
            طول قرارداداجاره نبایدبیش ازیکسال باشد.وهرسال باید اجاره نامه جدیدرا
            بارگذاری نمایند.
          </li>
        </ol>
        <br />
        <h3>
          بخشي از آيين نامه پرداخت كمك هزينه اجاره مسكن به طلاب حوزه علميه
          خراسان
        </h3>
        <br />
        <b>ماده 1:هدف</b>
        <br />
        به منظور فراهم كردن توجه بيشتر به طلاب فعال در امر تحصيل و تحقيق و رفع
        بخشي از دغدغه معيشتي آنان، كمك هزينه اجاره مسكن طبق ضوابط و مقررات اين
        آيين نامه به طلاب حوزه علميه خراسان پرداخت مي‌شود.
        <br />
        <br />
        <b>
          ماده 2: شرایط پرداخت کمک هزینه اجاره مسکن
        </b>
        <br />
        <ol>
          <li>
            داشتن پرونده تحصيلي فعال در مديريت حوزه علميه خراسان
          </li>
          <li>
            داشتن شهريه رسمي از حوزه علميه خراسان
          </li>
          <li>
            پيشرفت تحصيلي حداقل 2 پايه در هر 3 سال،برای طلاب شاغل به تحصیل
          </li>
          <li>
            متأهل بودن(رسما زندگی مشترک راآغازنموده باشد.)
          </li>
          <li>
            سكونت در محل تحصيل
          </li>
          <li>
            نداشتن مسكن شخصي و سازماني در مشهد و ساير شهرستانها
          </li>
          <li>
            نيازمندي متقاضي و مكفي نبودن درآمد او جهت تأمين هزينه مسكن و مخارج
            زندگي
          </li>
          <li>
            عدم اشتغال در نهادها با هر نوع عضويت(رسمي، پيماني، قراردادي)
          </li>
          <li>
            اسکن وبارگذاری اصل قرارداد بامشخصات کامل(حاوي مشخصات موجر، مشخصات
            مستاجر، تاريخ مدت اجاره، آدرس مورداجاره،مبلغ اجاره و رهن.)
          </li>
        </ol>
        <br />
        <b>تبصره</b>
        <br />
        تبصره 1: پس از اتمام مدت قرارداد اجاره درصورت تأخير در ارائه اجاره نامه
        جديد، حداكثر اجاره 2 ماه به عنوان معوقه پرداخت مي شود.
        <br />
        تبصره 2: روحانيوني كه مسكن مورد اجاره را رهن كامل نموده اند، مشمول
        دريافت كمك هزينه اجاره مسكن نمي باشند. ( مبلغ اجاره بايد به صورت متعارف
        باشد).
        <br />
        تبصره 3: پرداخت اولين كمك هزينه اجاره مسكن از زمان درخواست و پذيرش
        متقاضي، قابل پرداخت است و ماه هاي قبل از درخواست مشمول معوقه نمي شود.
      </div>
      <br />
      <br />

      <div style="width: 100%">
        <v-simple-checkbox v-model="showNext" :ripple="false"></v-simple-checkbox>
        <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
      </div>
    </v-card>
    <div class="confirm">
      <v-btn class="register" v-if="showNext" :class="!isMobile ? 'btnMargin' : ''" color="primary white--text" rounded
        @click="checkPermission" :disabled="apiRunning">
        {{ apiRunning ? "لطفا منتظر بمانید..." : "مرحله بعد" }}
      </v-btn>
    </div>
    <app-dialog @close="closeDialog"></app-dialog>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> نوع قرارداد </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select :items="items" item-text="text" item-value="value" v-model="type"></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> مبلغ رهن </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="rahn" maxlength="11" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> مبلغ اجاره </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="ejare" maxlength="11" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> کد طلبگی ضامن اول: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="guarantor1" maxlength="12" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> کد طلبگی ضامن دوم: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="guarantor2" maxlength="12" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ شروع قرارداد:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(1)">
            {{ startSelected ? startDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ پایان قرارداد:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(2)">
            {{ endSelected ? endDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>آدرس:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="address" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> تلفن: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="phone" maxlength="11" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" :cols="imgUrl != '' ? 8 : 12" sm="8">
          <v-file-input accept="image/*" label="پیوست مدرک" v-model="image"></v-file-input>
        </v-col>
        <v-col v-if="imgUrl != ''" class="d-flex" cols="8" sm="4">
          <a :href="imgUrl" target="_blank" style="margin: auto; margin-top: 30px">تصویر اجاره نامه</a>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register register2" rounded @click="applyRequest"
          :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
        </v-btn>
      </v-row>
    </v-card>
    <date-picker ref="datepicker1" v-model="startDate" :editable="false" :auto-submit="true" element="fileInput1"
      @change="onChangeDate($event, 1)"></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker ref="datepicker2" v-model="endDate" :editable="false" :auto-submit="true" element="fileInput2"
      :min="startDate" @change="onChangeDate($event, 2)"></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import { TODAY } from "@/utils/constants";
import moment from "moment-jalaali";
import Dialog from "@/components/Dialog";
import {
  saveEjareRequest,
  checkEjareApplyPermission,
} from "@/api/home-request";
export default {
  components: {
    appDialog: Dialog,
  },
  data() {
    return {
      showNext: false,
      showRequest: false,
      image: null,
      items: [
        { value: 1, text: "رسمی" },
        { value: 2, text: "دستی" },
      ],
      type: 0,
      rahn: "",
      ejare: "",
      guarantor1: "",
      guarantor2: "",
      startDate: TODAY,
      endDate: TODAY,
      startSelected: false,
      endSelected: false,
      address: "",
      phone: "",
      serial: "0",
      imgUrl: "",
    };
  },
  computed: {
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    active() {
      return this.$store.getters.currentHomeRequest;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.type = this.items.value;
    if (this.active.hasOwnProperty("FSerial")) {
      this.type = this.items[this.active.Type - 1].value;
      this.rahn = this.active.Cash;
      this.ejare = this.active.Rent;
      this.guarantor1 = this.active.G1NumSys;
      this.guarantor2 = this.active.G2NumSys;
      this.address = this.active.Address;
      this.phone = this.active.Tel.trim();
      this.startDate = this.active.StartDate;
      this.startSelected = true;
      this.endDate = this.active.EndDate;
      this.endSelected = true;
      this.serial = this.active.FSerial;
      this.imgUrl = process.env.VUE_APP_API_ENDPOINT + this.active.DocPicUrl;
    }
  },

  methods: {
    closeDialog() {
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    checkPermission() {
      checkEjareApplyPermission()
        .then((response) => {
          const data = response.data;
          if (data.Success) {
            window.scrollTo(0, 0)
            this.$router.push({
              query: {

                showRequest: "true"
              }
            });
          } else {
            this.$store.commit("SET_DIALOG_ICON", "exclamation");

            this.$store.commit("SET_DIALOG_TYPE", 0);

            this.$store.commit("SET_DIALOG_MESSAGE", data.Message);
            this.$store.commit("SET_DIALOG_SHOW", true);
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";

      if (this.rahn == "") {
        text = "میزان رهن نباید خالی باشد.";
      } else if (this.ejare == "") {
        text = "میزان اجاره نباید خالی باشد.";
      } else if (this.guarantor1 == "") {
        text = "ضامن اول بایستی انتخاب شود.";
      } else if (this.guarantor2 == "") {
        text = "ضامن دوم بایستی انتخاب شود.";
      } else if (!this.startSelected) {
        text = "لطفا زمان شروع را انتخاب کنید.";
      } else if (!this.endSelected) {
        text = "لطفا زمان پایان را انتخاب کنید.";
      } else if (this.startDate > this.endDate) {
        text = "زمان شروع بایستی پیش از زمان پایان باشد.";
      } else if (this.address == "") {
        text = "آدرس نباید خالی باشد.";
      } else if (this.phone == "") {
        text = " تلفن نباید خالی باشد.";
      } else if (this.image == null) {
        text = "تصویر قولنامه بایستی انتخاب شود.";
      } else {
        let startTime = moment(this.startDate, "jYYYY/jMM/jDD");
        let endTime = moment(this.endDate, "jYYYY/jMM/jDD");
        if (startTime.add(1, "years") < endTime) {
          text = "تاریخ اجاره حداکثر می تواند یک سال باشد.";
        }
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        saveEjareRequest(
          this.image,
          this.serial,
          this.guarantor1,
          this.guarantor2,
          this.startDate,
          this.endDate,
          this.rahn,
          this.ejare,
          this.type,
          this.address,
          this.phone
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    /**
     * user changed date
     */
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    goToIndex() {
      this.$router.push({ path: "/index" });
    },

    /**
     * check user input and  then send khorooj request
     */
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;
      window.scrollTo(0, 0)
    }
  },

};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}



.register2 {
  width: 300px !important;
  margin: 20px auto;
}

.v-text-field__details {
  display: none;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}

.fullForm {
  margin-bottom: 65px;
}
</style>
